import { Box, Card } from '@mui/material';
import { DateField, Labeled } from 'react-admin';

import { CraftTwoColumns } from 'src/components/CraftTwoColumns';

export const EditAside = () => (
  <Box ml={2} minWidth="25rem">
    <Card sx={{ p: 2 }}>
      <CraftTwoColumns
        left={
          <>
            <Box>
              <Labeled label="Created">
                <DateField source="created_at" showTime />
              </Labeled>
            </Box>
            <Box>
              <Labeled label="Deleted">
                <DateField source="deleted_at" showTime emptyText="N/A" />
              </Labeled>
            </Box>
          </>
        }
        right={
          <Box>
            <Labeled label="Updated">
              <DateField source="updated_at" showTime />
            </Labeled>
          </Box>
        }
      />
    </Card>
  </Box>
);

export default EditAside;
